import { takeLatest, put, call } from "@redux-saga/core/effects";
import {
  fetchPrjAsnSucc, fetchPrjAsnFailure,
  createPrjAsnFailure, createPrjAsnSucc, SETPrjAsnInit, updatePrjAsnSucc, updatePrjAsnFailure
} from "./prjAsnActions";
import { FETCH_PRJASN_START, SET_PRJASN_INIT, CREATE_PRJASN_START, UPDATE_PRJASN_START } from "./prjAsnTypes";
import { getPrjAsnAPI, createPrjAsnAPI, updatePrjAsnAPI } from "../../apis/pgapis"
import {  refreshApp } from "../ctrl/ctrlActions";
export function* onCreatePrjAsnAsync(payload) {
  try {
    const response = yield call(
      createPrjAsnAPI,
      payload
    );

    if (response === 200) {
      yield put(createPrjAsnSucc());
      try {
        const resApi = yield call(getPrjAsnAPI)
        yield put(fetchPrjAsnSucc(resApi))
      } catch (e) { yield put(fetchPrjAsnFailure(e)); }
    }

  } catch (e) {
    if(e?.response?.status === 403){ yield put(refreshApp(true))}
    yield put(createPrjAsnFailure(e));
  }
}

export function* onCreatePrjAsn() {
  yield takeLatest(CREATE_PRJASN_START, onCreatePrjAsnAsync);
}

export function* onFetchPrjAsnsAsync(action) {
  try {
    const response = yield call(getPrjAsnAPI)
    yield put(
      fetchPrjAsnSucc(
        response
      )
    )
  } catch (e) {
    if(e?.response?.status === 403){ yield put(refreshApp(true))}
    yield put(fetchPrjAsnFailure(e)); }
}

export function* onFetchPrjAsn() {
  yield takeLatest(FETCH_PRJASN_START, onFetchPrjAsnsAsync)
}

export function* onSetPrjAsnSync() {
  yield call(SETPrjAsnInit)
}


export function* onSetPrjAsn() {
  yield takeLatest(SET_PRJASN_INIT, onSetPrjAsnSync);
}

export function* onUpdatePrjAsnAsync(payload) {
  console.log(payload,"payload");
  try {
    const response = yield call(
      updatePrjAsnAPI,
      payload
    );

    if (response === 200) {
      yield put(updatePrjAsnSucc());
      try {
        const resApi = yield call(getPrjAsnAPI)
        yield put(
          fetchPrjAsnSucc(
            resApi
          )
        )
      } catch (e) { if(e?.response?.status === 403){ yield put(refreshApp(true))}
      console.log(e); yield put(fetchPrjAsnFailure(e)); }
    }

  } catch (e) {
    if(e?.response?.status === 403){ yield put(refreshApp(true))}
    yield put(updatePrjAsnFailure(e));
  }
}

export function* onUpdatePrjAsn() {
  yield takeLatest(UPDATE_PRJASN_START, onUpdatePrjAsnAsync);
}